export var testValidPostcode = function (value) {
    if (typeof value === "undefined" || !value.length)
        return false;
    var postcodeRegexUK = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/;
    var postcodeRegexIRE = /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}/;
    return postcodeRegexUK.test(value) || postcodeRegexIRE.test(value);
};
